/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_PasswordInputs */

const fr_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J’ai oublié mon mot de passe`)
};

const en_auth_forgot_password = /** @type {(inputs: Auth_Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I have forgotten my password`)
};

/**
* | output |
* | --- |
* | "I have forgotten my password" |
*
* @param {Auth_Forgot_PasswordInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_password = /** @type {((inputs?: Auth_Forgot_PasswordInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_PasswordInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_password(inputs)
	return fr_auth_forgot_password(inputs)
});